import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../../../scss/components/pages/signTime.scss';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { yearNames } from '../../../const/constant';

import Pagination from '../../Pagination';

import {
  getStaffSalaryList,
  InitAPIStatus
} from '../../../store/action';

class StaffSalaryList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currPage: 1,
      countOfPage: 10,
      selecteMonthList: [{id: '01', text: '1月'},{id: '02', text: '2月'},{id: '03', text: '3月'},{id: '04', text: '4月'},{id: '05', text: '5月'},{id: '06', text: '6月'},{id: '07', text: '7月'},{id: '08', text: '8月'},{id: '09', text: '9月'},{id: '10', text: '10月'},{id: '11', text: '11月'},{id: '12', text: '12月'}],
      selectYear: moment().format('YYYY'),
      selecteMonth: moment().format('MM')

    }
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleSearchButton = this.handleSearchButton.bind(this);
    this.onChangeMonthFunc = this.onChangeMonthFunc.bind(this);
    this.onChangeYearFunc = this.onChangeYearFunc.bind(this);
  }

  componentDidMount() {
    let {selectYear, selecteMonth} = this.state;
    this.props.getStaffSalaryList(selectYear + '-' + selecteMonth + '-01');
  }


  handleChangePage(page) {
    this.setState({
      currPage: page
    })
  }

  onChangeMonthFunc(e) {
    this.setState({
      selecteMonth: e.target.value
    })
  }

  onChangeYearFunc(e) {
    this.setState({
      selectYear: e.target.value
    })
  }

  handleSearchButton() {
    let {selectYear, selecteMonth} = this.state;
    this.setState({
      currPage: 1
    },() => {
      this.props.getStaffSalaryList(selectYear + '-' + selecteMonth + '-01');
    })
  }


  get pageStart() {
    const {currPage ,countOfPage} = this.state;
    return (currPage - 1) * countOfPage;
  }

  render() {
    let { staffSalaryListState } = this.props;
    let { countOfPage, selecteMonth, selecteMonthList, selectYear} = this.state;
    let totalPage = Math.ceil(staffSalaryListState.length / this.state.countOfPage);
    return (
    <div className="p-signTime">
      <div className="u-block">
        <div className="u-title">員工薪資表</div>
        <div className="search-box">
          <div className="date-input">
            <span>年：</span>
            <select value={selectYear} className="u-form__select" 
              onChange={this.onChangeYearFunc}
            >
              {
                yearNames.map(yearName => (
                  <option key={yearName} value={yearName}>西元{ yearName }</option>
                ))
              }
            </select>
          </div>
          <div className="date-input">
            <span>月：</span>
            <select value={selecteMonth} className="u-form__select" 
              onChange={this.onChangeMonthFunc}
            >
              {
                selecteMonthList.map(month => (
                  <option key={month.id} value={month.id}>{ month.text }</option>
                ))
              }
            </select>
          </div>
          <button className="btn btn-md save m-l-8" onClick={this.handleSearchButton}>查詢</button>
        </div>
        <div className="u-table-responsive">
          <table className="u-table">
            <thead>
              <tr>
                <th>員工編號</th>
                <th>姓名</th>
                <th>職位</th>
                <th>總工時</th>
                <th>加班時數</th>
                <th>薪資</th>
              </tr>
            </thead>
            <tbody>
              {
                staffSalaryListState.slice(this.pageStart, this.pageStart + countOfPage).map(staff => {
                  return (
                    <tr key={staff.id}>
                      <td>{staff.id}</td>
                      <td>{staff.name}</td>
                      <td>{staff.jobType}</td>
                      <td>{staff.totalWorkTime}</td>
                      <td>{staff.overWorkTime}</td>
                      <td>{staff.pay}</td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>
        <div className="u-notice">※無資料和店長確認。</div>
        <div className="pagination-box">
          <Pagination
            currPage={this.state.currPage} totalPage={totalPage}
            onChangPage={this.handleChangePage}
          />
        </div>
      </div>
    </div>
    )
  }
}

const mapStateToProps = (store) => ({
  SendAPIState: store.SendAPIStatusState,
  staffSalaryListState: store.staffSalaryListState,
})

export default connect(mapStateToProps,{
  getStaffSalaryList,
  InitAPIStatus
})(StaffSalaryList)